import React, { useState } from 'react';
import propTypes from 'prop-types';

// components
import TextInput from 'common/TextInput';

const PlantingPlanTextInput = ({
  children,
  dataTestId,
  value = '',
  displayValue = value?.toString() || '',
  label,
  onChange,
  placeholder = '',
  validationResult
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
    onChange(value);
  };

  return (
    <TextInput
      dataTestId={dataTestId}
      label={label}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      placeholder={placeholder}
      validationResult={validationResult}
      value={isFocused ? value : displayValue}
    >
      {children}
    </TextInput>
  );
};

PlantingPlanTextInput.propTypes = {
  children: propTypes.node,
  dataTestId: propTypes.string.isRequired,
  displayValue: propTypes.string,
  label: propTypes.oneOfType([propTypes.object, propTypes.string]),
  onChange: propTypes.func.isRequired,
  placeholder: propTypes.string,
  validationResult: propTypes.object,
  value: propTypes.oneOfType([propTypes.number, propTypes.string])
};

export default PlantingPlanTextInput;
